// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3Y5zR","disabled":"FileBtn_disabled__1N5PN","warn":"FileBtn_warn__Ea3BX","fade":"FileBtn_fade__jVExN"};